module.exports = __webpack_public_path__ + "static/media/logo-no-claim.adb32af0.png";